import {ChangeDetectionStrategy, ChangeDetectorRef, Component, SecurityContext, ViewChild, ViewContainerRef,} from '@angular/core';
import * as DetailScreen from '../screen-lib';
import {DetailPanelComponent} from '../detail-panel/detail-panel.component';
import {DomService} from '../../../../services/dom-service/dom.service';
import {OldDetailsScript} from '../details-scripts/old-details-script';
import {ProductOverviewRequest} from '../../../../services/product-overview/product-overview-request.model';
import * as $ from 'jquery';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {environment} from '../../../../../environments/environment';
import {ButtonData} from '../mapping-classes/button-data';
import {DetailButtonComponent} from '../detail-button/detail-button.component';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {PopupService} from '../../popup-component/popup.service/popup.service';

@Component({
  selector: 'app-detail-screen',
  templateUrl: './detail-screen.component.html',
  styleUrls: ['./detail-screen.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailScreenComponent extends OldDetailsScript {
  @ViewChild('button', {read: ViewContainerRef}) buttonContainer: ViewContainerRef;
  @ViewChild('panel', {read: ViewContainerRef}) panelContainer: ViewContainerRef;

  data;
  type: string;
  title: string;
  screenInstance;
  secondScreenInstance;
  screenInstancePanels: DetailPanelComponent[];
  screenInstanceButtons: DetailButtonComponent[];
  expandAll = 'Alles uitklappen';
  collapseAll = 'Alles inklappen';
  allExpanded: boolean;
  showDetails: boolean;
  hideExpandButton: boolean;
  hideErrorText: boolean;
  showActuality: boolean;
  actualityDateTime;
  errorText: string;
  defaultExpandedList: string[] = ['Passen', 'Rabo Online Keys', 'Fysieke passen'];

  constructor(
    public domService: DomService,
    private html_sanitizer: DomSanitizer,
    public changeRef: ChangeDetectorRef,
    popupService: PopupService) {
    super(popupService);
    this.allExpanded = false;
    this.showDetails = false;
    this.screenInstancePanels = [];
    this.screenInstanceButtons = [];

  }

  createScreen(response, uri: string, secondDetailScreen?: DetailScreenComponent) {
    this.screenInstancePanels = [];
    this.secondScreenInstance = [];
    this.screenInstanceButtons = [];
    this.allExpanded = false;
    this.showDetails = true;
    this.type = 'new';
    this.hideExpandButton = true;
    this.changeRef.detectChanges();
    this.panelContainer.clear();
    this.buttonContainer.clear();
    this.secondScreenInstance = secondDetailScreen;
    this.screenInstance = new DetailScreen[this.capitalizeFirstLetter(uri)](response);
    this.title = this.screenInstance.title;
    this.actualityDateTime = this.screenInstance.actualityDateTime;
    if (this.actualityDateTime) {
      this.showActuality = true;
    } else {
      this.showActuality = false;
    }
    this.errorText = this.screenInstance.errorText;
    this.hideErrorText = (this.errorText === null || this.errorText === undefined);
    this.changeRef.detectChanges();
    if (this.screenInstance.buttons) {
      this.screenInstance.buttons.forEach((button) => {
        this.screenInstanceButtons.push(this.createDetailButtonComponent(button));
      });
      this.changeRef.detectChanges();
    }
    if (this.screenInstance.panels) {
      this.hideExpandButton = false;
      let first = (this.screenInstance.panels.length > 1) ? true : false;
      this.screenInstance.panels.forEach((panel) => {
        const panelComponent = this.createPanelComponent(panel, first);
        const expandByName = this.expandByName(panel);
        this.screenInstancePanels.push(panelComponent);
        first = false;
        this.changeRef.detectChanges();
        panelComponent.initializeNameAndValueComponents();
        panelComponent.initializeSubPanelComponents();
        if (expandByName) {
          panelComponent.onClick();
        }

      });
    }
    this.scrollIntoView();
  }

  private expandByName(panel: DetailPanel): boolean {
    return this.defaultExpandedList.indexOf(panel.name) > -1 ? true : false;
  }

  public createPanelComponent(panel: DetailPanel, first: boolean, expandByName: boolean = false): DetailPanelComponent {
    if (!this.panelContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(DetailPanelComponent, this.panelContainer);
    const panelComponentToReturn = viewRef.instance as DetailPanelComponent;
    panelComponentToReturn.restrictedData = this.screenInstance.restrictedData;
    panelComponentToReturn.title = panel.name;
    panelComponentToReturn.expandable = true;
    if (first) {
      panelComponentToReturn.expanded = true;
    }
    panelComponentToReturn.lazyLoaded = panel.lazyLoaded;
    panelComponentToReturn.hasTable = panel.hasTable;
    panelComponentToReturn.errorText = panel.errorText;
    panelComponentToReturn.hideErrorText = (panelComponentToReturn.errorText === null || panelComponentToReturn.errorText === undefined);
    panelComponentToReturn.lazyLoadingData = panel.lazyLoadingData;
    panelComponentToReturn.nameAndValues = panel.nameAndValues;
    panelComponentToReturn.subPanels = panel.subPanels;
    panelComponentToReturn.parent = this;
    return panelComponentToReturn;
  }

  createDetailButtonComponent(button: ButtonData): DetailButtonComponent {
    if (!this.buttonContainer) {
      return null;
    }
    const viewRef = this.domService.addComponentToDOM(DetailButtonComponent, this.buttonContainer);
    const buttonComponent = viewRef.instance as DetailButtonComponent;
    buttonComponent.id = button.id;
    buttonComponent.arrangementNumber = button.arrangementNumber;
    buttonComponent.administrationCode = button.administrationCode;
    buttonComponent.commercialProductTypeCode = button.commercialProductTypeCode;
    buttonComponent.label = button.label || null;
    buttonComponent.setName();
    buttonComponent.setToken(button.tokenSort);
    buttonComponent.setUrl(button.url);
    buttonComponent.setData(button.data);
    return buttonComponent;
  }

  private capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  expandOrCollapseAll() {
    this.screenInstancePanels.forEach((panelComponent) => {
      if (!this.allExpanded) {
        panelComponent.expand();
      } else {
        panelComponent.expanded = false;
      }
    });
    this.allExpanded = !this.allExpanded;
    this.changeRef.detectChanges();
    this.scrollIntoView();
  }

  panelsAreAllExpanded(): boolean {
    return this.screenInstancePanels.every((panelComponent) => {
      return panelComponent.expanded;
    });
  }

  setOldDetails(details, detailsURI, requiredArrangementData?) {
    this.showDetails = true;
    this.type = 'old';
    this.data = details;
    this.changeRef.detectChanges();
    this.scrollIntoView();

    this.initProductServicePopUpInteraction(requiredArrangementData);

    if (detailsURI === 'onlinekeys') {
      this.onInitOnlineKeysView();
      this.changeRef.detectChanges();
    }
    if (detailsURI === 'betalenbinnenland') {
      this.initBetalenBinnenlandView();
      this.changeRef.detectChanges();
    }
    if (detailsURI === 'geldontvangenbinnenland') {
      this.initDynamicTableDetailsView(6);
      this.changeRef.detectChanges();
    }
    if (detailsURI === 'bestellingen' || detailsURI === 'stortingen') {
      this.initDynamicTableDetailsView(5);
      this.changeRef.detectChanges();
    }
    if (detailsURI === 'rcclusterdetails') {
      this.initRekeningCourantCluserDetailsView();
      this.changeRef.detectChanges();
    }
  }

  public sameAsHtml(html_content) {
    return this.html_sanitizer.bypassSecurityTrustHtml(html_content);
  }

  ajaxCallForDetails(arrangementNo, productServiceUrl, thisClass) {
    let data: string;
    const dataAsUnknown = thisClass.data as unknown;
    data = dataAsUnknown as string;
    let firstPart;
    let secondPart;
    const splitData = data.split('<div id="onlinekeyarrangement" style="margin-top: 20px"></div>', 2);
    if (splitData.length === 1 && splitData[0].includes('<div id="onlinekeyarrangement" style="margin-top: 20px">')) {
      firstPart = data.split('<div id="onlinekeyarrangement" style="margin-top: 20px">', 2)[0];
      secondPart = '<script type="text/javascript">' + data.split('<script type="text/javascript">', 3)[2];
    } else {
      firstPart = splitData[0];
      secondPart = splitData[1];
    }
    let typeCode = productServiceUrl.split('typeCode=', 2)[1];
    typeCode = typeCode.split('&arrangementNumber', 2)[0];
    $.ajax({
      url: environment.civViewBaseURL + 'productoverview/onlinekeyarrangement',
      type: 'POST',
      data: JSON.stringify({
        arrangementNumber: arrangementNo,
        administrationCode: '1201',
        commercialProductTypeCode: typeCode,
        parametersToken: ProductOverviewRequest.parametersToken,
      }),
      headers: {
        'Authorization': ProductOverviewRequest.token,
        'MFA-Authorization': ProductOverviewRequest.token,
        'Graph-Authorization': ProductOverviewRequest.graphToken,
        'Content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      cache: false,
      processData: false,
      success(response, textStatus, jqXHR) {
        const filteredResponse = $(response).filter('#content');
        const middlePart = '<div id="onlinekeyarrangement" style="margin-top: 20px">' + filteredResponse[0].innerHTML + '</div>';
        const totalHtml = firstPart + middlePart + secondPart;
        thisClass.data = totalHtml;
        thisClass.changeRef.detectChanges();
        thisClass.scrollIntoView();
      },
      error(jqXHR, textStatus, errorThrown) {
        const middlePart = '<div id="onlinekeyarrangement" style="margin-top: 20px">' + $(jqXHR) + '</div>';
        const totalHtml = firstPart + middlePart + secondPart;
        thisClass.data = totalHtml;
        thisClass.changeRef.detectChanges();
        thisClass.scrollIntoView();
      },
    });
  }

  private scrollIntoView() {
    const el = document.getElementById('offset-anchor');
    el.scrollIntoView({behavior: 'smooth', block: 'start'});
  }

}
